import React from 'react';
import './RegisterAfaziliLeftSide.css';

const RegisterAfaziliLeftSide = () => {
    return (
        <section className="register-afazili-left-section">
            <p className='base-metin'>Uygun resimler ya da kurumsal bir <a href='deneme'>illüstrasyon</a></p>
            <p className='afazili-metin'>Afazili ya da Afazili Yakını</p>
        </section>
    );
};

export default RegisterAfaziliLeftSide;
